import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconShoppingBag = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="yfm-icon yfm-icon-shopping-bag"
      {...omit(props, ["className"])}
    >
      <rect width="24" height="24" fill="url(#pattern0_16320_565)" />
      <defs>
        <pattern
          id="pattern0_16320_565"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_16320_565" transform="scale(0.0196078)" />
        </pattern>
        <image
          id="image0_16320_565"
          width="51"
          height="51"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
);

IconShoppingBag.displayName = "IconShoppingBag";

export default IconShoppingBag;
